/**
 * Scoped CSS injected into the React host via a <style> tag.
 * All rules are namespaced under `.hre-root` or the `.hre-` prefix so they
 * cannot bleed into the rest of the app. The iframe document has its own
 * separate stylesheet injected via `utils/iframe.ts`.
 */
const editorUiStyles = `

/* ─── Root ─────────────────────────────────────────────────────────────── */

.hre-root {
  font-family: Roboto, Helvetica, Arial, sans-serif;
  color: #1f2937;
}
.hre-root button,
.hre-root select,
.hre-root input {
  font-family: inherit;
}
.hre-root button {
  border: none;
  background: transparent;
}

/* ─── Toolbar shell ─────────────────────────────────────────────────────── */

.hre-toolbar {
  background: #fff;
  border-bottom: 1px solid #e0e0e0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}

/* ─── Toolbar button ────────────────────────────────────────────────────── */

.hre-toolbar-btn {
  height: 32px;
  min-width: 32px;
  padding: 0 8px;
  border-radius: 6px;
  border: 1px solid transparent;
  color: #4b5563;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}
.hre-toolbar-btn:hover                { background: #f5f5f5; }
.hre-toolbar-btn:disabled             { opacity: 0.55; cursor: not-allowed; }
.hre-toolbar-btn:disabled:hover       { background: #fff; }
.hre-toolbar-btn.active               { background: #e3f2fd; color: #1565c0; border-color: #bbdefb; }
.hre-toolbar-btn.danger               { color: #d32f2f; }
.hre-toolbar-btn.danger:hover         { background: #ffebee; }

/* ─── Select / separator / chip ─────────────────────────────────────────── */

.hre-select {
  height: 30px;
  border: 1px solid #d0d7de;
  border-radius: 6px;
  background: #fff;
  color: #374151;
  font-size: 12px;
  padding: 0 8px;
}

.hre-sep {
  width: 1px;
  height: 20px;
  background: #e5e7eb;
  margin: 0 4px;
}

/* ─── Color picker controls ─────────────────────────────────────────────── */

.hre-color-input {
  width: 26px;
  height: 26px;
  padding: 0;
  border: 1px solid #d0d7de;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
}
.hre-color-input::-webkit-color-swatch-wrapper { padding: 2px; }
.hre-color-input::-webkit-color-swatch         { border: none; border-radius: 4px; }

.hre-color-wrap {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 2px;
}
.hre-color-icon {
  font-size: 12px;
  font-weight: 700;
  color: #4b5563;
  line-height: 1;
}

/* ─── Tailwind-style utilities ──────────────────────────────────────────── */

.flex { display: flex; }
.flex-col { flex-direction: column; }
.items-center { align-items: center; }
.gap-1 { gap: 4px; }
.gap-2 { gap: 8px; }
.flex-1 { flex: 1 1 0%; }
.flex-shrink-0 { flex-shrink: 0; }

.max-w-5xl { max-width: 64rem; }
.min-h-\\[40px\\] { min-height: 40px; }

.px-2 { padding-left: 8px; padding-right: 8px; }
.px-3 { padding-left: 12px; padding-right: 12px; }
.px-4 { padding-left: 16px; padding-right: 16px; }
.px-6 { padding-left: 24px; padding-right: 24px; }

.py-0\\.5 { padding-top: 2px; padding-bottom: 2px; }
.py-1\\.5 { padding-top: 6px; padding-bottom: 6px; }
.py-2 { padding-top: 8px; padding-bottom: 8px; }
.py-3 { padding-top: 12px; padding-bottom: 12px; }
.py-6 { padding-top: 24px; padding-bottom: 24px; }

.mb-1\\.5 { margin-bottom: 6px; }
.ml-auto { margin-left: auto; }
.mx-auto { margin-left: auto; margin-right: auto; }

.rounded { border-radius: 4px; }
.border-b { border-bottom: 1px solid; }

.bg-white { background: #fff; }
.bg-gray-100 { background: #f3f4f6; }

.text-xs { font-size: 12px; }
.text-\\[10px\\] { font-size: 10px; }
.text-\\[11px\\] { font-size: 11px; }
.font-semibold { font-weight: 600; }
.text-center { text-align: center; }
.text-gray-500 { color: #6b7280; }
.text-gray-600 { color: #4b5563; }

.overflow-auto { overflow: auto; }
.overflow-hidden { overflow: hidden; }

.shadow-2xl { box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25); }
.transition-colors { transition: background-color 0.15s, color 0.15s, border-color 0.15s; }
.select-none { user-select: none; }
.outline-none { outline: none; }
`;

export default editorUiStyles;
